import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const SystemEngineer = () => {
  const systemEngineerProgram = [
    {
      title: "Architecture et conception de systèmes",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Sécurité Systèmes et réseaux",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "Implémentation, intégration et test du système",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "ASPICE (Automotive SPICE)",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Les Méthodes agiles",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Redaction de synthèse",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Logiciels de planification et de gestion JIRA",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Linux / BASH",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Réseaux: Ethernet / Bus CAN",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Algorithmique",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Debug GDB / DDD/ ASAN",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Matlab / Simulink",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "SYSML",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Validation et Tests des Logiciels",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "La gestion des exigences avec DOORS",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Autosar (Automotive Open System Architecture)",
      img: "/assets/images/icon/setting-square.svg",
    },
    {
      title: "Projet de fin cursus",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Automobile"
      titleColor="#2424FF"
      title="System Engineer"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            System Engineer, après une formation accélérée de 11 semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/automobile.png"
      program={systemEngineerProgram}
      formId="6e188b83-21e2-42ff-a28d-be4d83808bec"
    />
  );
};

export default SystemEngineer;
